@if (error) {
  <mbs-alert
    class="mb-4"
    [icon]="true"
    [type]="mbsPopupType.danger"
    >{{ error }}</mbs-alert
  >
}

<mbs-card class="card-form">
  <mbs-card-header>
    <ng-template>
      <div class="d-flex align-items-center">
        <span class="mbs-storage mbs-storage-sm mbs-storage_{{ storageType | storageIcon }} mr-2"></span>
        <h4 class="text-lg m-0">{{ storageType | storageDisplayName }}</h4>
      </div>
    </ng-template>
  </mbs-card-header>

  <mbs-card-group>
    <ng-container
      [ngTemplateOutlet]="field"
      [ngTemplateOutletContext]="{
        label: 'shared:common.displayName' | i18next: { format: 'capitalize' },
        data: accountDisplayName || '-'
      }"></ng-container>

    @if (!isNil(cloudStorageId)) {
      <ng-container
        [ngTemplateOutlet]="field"
        [ngTemplateOutletContext]="{
          label: 'storages:accountId' | i18next: { format: 'capitalize' },
          data: cloudStorageId
        }"></ng-container>
    }

    @if (!isNil(credentialFormValue?.user)) {
      <ng-container
        [ngTemplateOutlet]="field"
        [ngTemplateOutletContext]="{
          label: 'storages:addStorageAccountWizard.inputCredentialsStep.labels.username' | i18next,
          data: credentialFormValue?.user
        }"></ng-container>
    }

    @if (!isNil(credentialFormValue?.httpEndpoint)) {
      <ng-container
        [ngTemplateOutlet]="field"
        [ngTemplateOutletContext]="{
          label: 'storages:addStorageAccountWizard.inputCredentialsStep.labels.http' | i18next,
          data: credentialFormValue?.httpEndpoint || '-'
        }"></ng-container>
    }

    @if (!isNil(credentialFormValue?.projectId)) {
      <ng-container
        [ngTemplateOutlet]="field"
        [ngTemplateOutletContext]="{
          label: 'storages:addStorageAccountWizard.inputCredentialsStep.labels.projectID' | i18next,
          data: credentialFormValue?.projectId || '-'
        }"></ng-container>
    }

    @if (!isNil(credentialFormValue?.httpsEndpoint)) {
      <ng-container
        [ngTemplateOutlet]="field"
        [ngTemplateOutletContext]="{
          label: 'storages:addStorageAccountWizard.inputCredentialsStep.labels.https' | i18next,
          data: credentialFormValue?.httpsEndpoint || '-'
        }"></ng-container>
    }

    @if (!isNil(ignoreCertificate)) {
      <ng-container
        [ngTemplateOutlet]="field"
        [ngTemplateOutletContext]="{
          label: 'storages:addStorageAccountWizard.inputCredentialsStep.labels.ignoreCertificate' | i18next,
          data: ignoreCertificate | boolDisplay: 'enabled'
        }"></ng-container>
    }

    @if (!isNil(isVersioningEnabled)) {
      <ng-container
        [ngTemplateOutlet]="field"
        [ngTemplateOutletContext]="{
          label: 'storages:addStorageAccountWizard.inputCredentialsStep.labels.versioning' | i18next,
          data: isVersioningEnabled | boolDisplay: 'enabled'
        }"></ng-container>
    }

    @if (!isNil(keepCredentialsOnEndpoint)) {
      <ng-container
        [ngTemplateOutlet]="field"
        [ngTemplateOutletContext]="{
          label: 'storages:addStorageAccountWizard.inputCredentialsStep.labels.keepCredentials' | i18next,
          data: keepCredentialsOnEndpoint | boolDisplay: 'enabled'
        }"></ng-container>
    }

    @if (!isNil(isSyntheticBackupAllowed)) {
      <ng-container
        [ngTemplateOutlet]="field"
        [ngTemplateOutletContext]="{
          label: 'storages:addStorageAccountWizard.inputCredentialsStep.labels.allowSyntheticFullBackup' | i18next,
          data: isSyntheticBackupAllowed | boolDisplay: 'enabled'
        }"></ng-container>
    }

    @if (!isNil(useSignatureVersion4)) {
      <ng-container
        [ngTemplateOutlet]="field"
        [ngTemplateOutletContext]="{
          label: 'storages:addStorageAccountWizard.inputCredentialsStep.labels.signatureVersion' | i18next,
          data: useSignatureVersion4 ? 4 : 2
        }"></ng-container>
    }

    @if (!isNil(useVHostRequestStyle)) {
      <ng-container
        [ngTemplateOutlet]="field"
        [ngTemplateOutletContext]="{
          label: 'storages:addStorageAccountWizard.inputCredentialsStep.accessStyle' | i18next,
          data: accessStyle
        }"></ng-container>
    }

    @if (!isNil(credentialFormValue?.accountType) && storageType?.value === storageTypeEnum.Azure) {
      <ng-container
        [ngTemplateOutlet]="field"
        [ngTemplateOutletContext]="{
          label: 'storages:addStorageAccountWizard.inputCredentialsStep.labels.accountType' | i18next,
          data: credentialFormValue?.azureAccountTypeValue
        }"></ng-container>
    }

    @if (!isNil(credentialFormValue?.endpoint)) {
      <ng-container
        [ngTemplateOutlet]="field"
        [ngTemplateOutletContext]="{
          label: 'storages:addStorageAccountWizard.inputCredentialsStep.labels.serviceEndpoint' | i18next,
          data: credentialFormValue?.endpoint
        }"></ng-container>
    }

    @if (!isNil(credentialFormValue?.isPrivateStorage)) {
      <ng-container
        [ngTemplateOutlet]="field"
        [ngTemplateOutletContext]="{
          label: 'storages:addStorageAccountWizard.inputCredentialsStep.labels.checkCredentials' | i18next,
          data: credentialFormValue?.isPrivateStorage | boolDisplay: 'enabled'
        }"></ng-container>
    }

    @if (!isNil(credentialFormValue?.useSSL)) {
      <ng-container
        [ngTemplateOutlet]="field"
        [ngTemplateOutletContext]="{
          label: 'storages:addStorageAccountWizard.inputCredentialsStep.labels.useSSL' | i18next,
          data: credentialFormValue?.useSSL | boolDisplay: 'enabled'
        }"></ng-container>
    }

    @if (!isNil(credentialFormValue?.keepAlive)) {
      <ng-container
        [ngTemplateOutlet]="field"
        [ngTemplateOutletContext]="{
          label: 'storages:addStorageAccountWizard.inputCredentialsStep.labels.keepAlive' | i18next,
          data: credentialFormValue?.keepAlive | boolDisplay: 'enabled'
        }"></ng-container>
    }

    @if (!isNil(credentialFormValue?.usePassiveMode)) {
      <ng-container
        [ngTemplateOutlet]="field"
        [ngTemplateOutletContext]="{
          label: 'storages:addStorageAccountWizard.inputCredentialsStep.labels.usePassiveMode' | i18next,
          data: credentialFormValue?.usePassiveMode | boolDisplay: 'enabled'
        }"></ng-container>
    }
  </mbs-card-group>

  @if (formValue()?.arnRoleOptions?.specificBuckets?.length && formValue()?.arnRoleOptions?.restrictBuckets) {
    <mbs-card-group>
      <ng-container
        [ngTemplateOutlet]="field"
        [ngTemplateOutletContext]="{
          label: 'storages:addStorageAccountWizard.summaryStep.specificBuckets' | i18next,
          data: getSpecificBucketsNames()
        }"></ng-container>
    </mbs-card-group>
  }

  @if (mode === creationMode.Create) {
    <mbs-card-group>
      <ng-container
        [ngTemplateOutlet]="field"
        [ngTemplateOutletContext]="{
          label: 'storages:addStorageAccountWizard.summaryStep.destinationDisplayName' | i18next,
          data: formValue()?.destination?.displayBucketName || '-'
        }"></ng-container>
      <ng-container
        [ngTemplateOutlet]="field"
        [ngTemplateOutletContext]="{
          label: 'shared:modals.addDestinationBucket.bucketName' | i18next: { type: getBucketType(), format: 'capitalize' },
          data: formValue()?.destination?.bucketName || '-'
        }"></ng-container>
      @if (!isNil(storageClass)) {
        <ng-container
          [ngTemplateOutlet]="field"
          [ngTemplateOutletContext]="{
            label: 'shared:modals.addDestinationBucket.storageClass' | i18next: { format: 'capitalize' },
            data: storageClass
          }"></ng-container>
      }
      @if (!isNil(region)) {
        <ng-container
          [ngTemplateOutlet]="field"
          [ngTemplateOutletContext]="{
            label:
              (googleCloudAccounts.includes(storageType) ? 'shared:captions.location' : 'shared:storages.region')
              | i18next: { format: 'capitalize' },
            data: region
          }"></ng-container>
      }
      @if (!isNil(immutability)) {
        <ng-container
          [ngTemplateOutlet]="field"
          [ngTemplateOutletContext]="{
            label: 'storages:destinations.objectLock' | i18next,
            data: immutability | boolDisplay: 'enabled'
          }"></ng-container>
      }
      @if (!isNil(googleSubregion)) {
        <ng-container
          [ngTemplateOutlet]="field"
          [ngTemplateOutletContext]="{
            label: 'shared:modals.addDestinationBucket.regionalLocation' | i18next: { format: 'capitalize' },
            data: googleSubregion
          }"></ng-container>
      }
      @if (!isNil(s3Accelerator)) {
        <ng-container
          [ngTemplateOutlet]="field"
          [ngTemplateOutletContext]="{
            label: 'shared:modals.addDestinationBucket.s3AcceleratorTitle' | i18next: { format: 'capitalize' },
            data: s3Accelerator | boolDisplay: 'enabled'
          }"></ng-container>
      }
      @if (!isNil(credentialFormValue?.subscriptionName)) {
        <ng-container
          [ngTemplateOutlet]="field"
          [ngTemplateOutletContext]="{
            label: 'storages:addStorageAccountWizard.inputCredentialsStep.labels.subscription' | i18next: { format: 'capitalize' },
            data: credentialFormValue?.subscriptionName
          }"></ng-container>
      }
    </mbs-card-group>
  }

  @if (mode === creationMode.Create) {
    <mbs-card-group>
      <ng-container
        [ngTemplateOutlet]="field"
        [ngTemplateOutletContext]="{
          label: 'shared:common.companies' | i18next: { format: 'title' },
          data: selectedCompanies?.join(', ')
        }"></ng-container>
    </mbs-card-group>
  }
</mbs-card>

<ng-template
  #field
  let-data="data"
  let-label="label">
  <div class="add-storage-account-summary-field">
    <h5 class="m-0">{{ label }}</h5>
    <mbs-text-ellipsis [tooltip]="data">
      {{ data || '-' }}
    </mbs-text-ellipsis>
  </div>
</ng-template>
